module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "m-b-5 ovf-hd"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addShow),
      expression: "addShow"
    }],
    staticClass: "fl m-r-30"
  }, [_c('router-link', {
    staticClass: "btn-link-large add-btn",
    attrs: {
      "to": "add"
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("  添加轮播\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "fl w-260"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入标题/内容",
      "clearable": ""
    },
    model: {
      value: (_vm.keywords),
      callback: function($$v) {
        _vm.keywords = $$v
      },
      expression: "keywords"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.search()
      }
    },
    slot: "append"
  })], 1)], 1)]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "height": _vm.setHeight.page_height,
      "border": ""
    },
    on: {
      "selection-change": _vm.selectItem
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "title",
      "label": "标题"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "url",
      "label": "跳转地址"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "img",
      "label": "图片",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.img) ? _c('el-popover', {
          attrs: {
            "placement": "right-end",
            "width": "600",
            "trigger": "click"
          }
        }, [_c('img', {
          attrs: {
            "src": scope.row.img,
            "width": "100%"
          }
        }), _vm._v(" "), _c('img', {
          attrs: {
            "slot": "reference",
            "src": scope.row.img,
            "width": "200",
            "height": "95"
          },
          slot: "reference"
        })]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [(scope.row.status == 1) ? _c('span', {
          staticStyle: {
            "color": "#0c0"
          }
        }, [_vm._v("正常")]) : (scope.row.status == 0) ? _c('span', {
          staticStyle: {
            "color": "#bb0"
          }
        }, [_vm._v(_vm._s(_vm._f("status")(scope.row.status)))]) : (scope.row.status == -1) ? _c('span', {
          staticStyle: {
            "color": "#d00"
          }
        }, [_vm._v(_vm._s(_vm._f("status")(scope.row.status)))]) : _vm._e()])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [(scope.row.type == 1) ? _c('span', [_vm._v("内部跳转")]) : (scope.row.type == 2) ? _c('span', [_vm._v("外链")]) : _vm._e()])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_c('span', [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'lunboEdit',
                params: {
                  id: scope.row.id
                }
              })
            }
          }
        }, [_vm._v("编辑")])], 1)])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pos-rel p-t-20"
  }, [_c('btnGroup', {
    attrs: {
      "selectedData": _vm.multipleSelection,
      "type": 'lunbo'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "block pages"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next",
      "page-size": _vm.limit,
      "current-page": _vm.currentPage,
      "total": _vm.dataCount
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-175dbba4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Appistrative/company/lunbo/list.vue
// module id = 1807
// module chunks = 2